import api from "../../Utils/interceptors";

export const CHAT_SEND_REQUEST = "CHAT_SEND_REQUEST";
export const CHAT_SEND_SUCCESS = "CHAT_SEND_SUCCESS";
export const CHAT_SEND_FAIL = "CHAT_SEND_FAIL";
export const CHAT_HISTORY_REQUEST = "CHAT_HISTORY_REQUEST";
export const CHAT_HISTORY_SUCCESS = "CHAT_HISTORY_SUCCESS";
export const CHAT_HISTORY_FAIL = "CHAT_HISTORY_FAIL";
export const CHAT_CLEAR = "CHAT_CLEAR";
export const CHAT_ADD_USER_MESSAGE = "CHAT_ADD_USER_MESSAGE";

export const sendChatMessage = (message) => async (dispatch) => {
  try {
    dispatch({ type: CHAT_ADD_USER_MESSAGE, payload: message });
    dispatch({ type: CHAT_SEND_REQUEST });

    const { data } = await api.post("/chat", { message });

    dispatch({
      type: CHAT_SEND_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: CHAT_SEND_FAIL,
      payload:
        error.response?.data?.message || "Failed to send message. Please try again.",
    });
  }
};

export const getChatHistory = () => async (dispatch) => {
  try {
    dispatch({ type: CHAT_HISTORY_REQUEST });
    const { data } = await api.get("/chat/history");
    dispatch({ type: CHAT_HISTORY_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: CHAT_HISTORY_FAIL,
      payload: error.response?.data?.message || "Failed to load history",
    });
  }
};

export const clearChatHistory = () => async (dispatch) => {
  try {
    await api.delete("/chat/history");
    dispatch({ type: CHAT_CLEAR });
  } catch (error) {
    console.error("Failed to clear chat history:", error);
  }
};
